import React, { Fragment, useContext } from "react";
import { EligibilityContext } from "../../contexts/EligibilityContext";

import { notDiseaseFund } from "../../helpers/fund";

const patientPortalURL = "https://panfoundation.my.site.com/s/nonAuthFlow";

const mailToSubject = encodeURIComponent(
  "Get $500 in transportation assistance"
);
const mailToBody = encodeURIComponent(
  "Hello,\r\rYou may be eligible to receive financial support for your transportation expenses through the PAN Foundation transportation fund. The fund helps you pay for travel to improve your overall health.\r\rHOW TO APPLY\rYou or your caregiver can apply by visiting https://panfoundation.org/transportation.\r\rIf your application is approved, you will get a $500 prepaid Visa debit card in the mail to use for covered expenses. Note: this grant only covers travel costs, not the purchase of goods.\r\rLEARN MORE\rIf you have questions about how the program works, you can review transportation fund FAQs on the PAN Foundation website here https://www.panfoundation.org/transportation-faqs."
);

const Apply = () => {
  const context = useContext(EligibilityContext);

  return (
    <div className="f-scale-body u-richtext">
      {context.state.role === "patient" && (
        <Fragment>
          <p className="f-h3 u-mb1" style={{ margin: 0 }}>
            You may be eligible for this fund!
          </p>

          {!notDiseaseFund(context.state.diseaseFund.fundId) && (
            <>
              <p>
                Based on our pre-screen, you are eligible to receive assistance
                from this fund.
              </p>
              <p>
                You can <a href="https://panapply.org/" target="_blank" rel="noopener">apply online 24/7 at panapply.org</a>, or by phone during business hours. To apply by phone, call us at 1-866-316-7263 Monday through Friday, 9 a.m. to 5:30 p.m. ET.
              </p>
              <p>
                Healthcare providers and pharmacies can apply on behalf of their patients.
              </p>
            </>
          )}

          {/* If the transportation fund was selected show the appropriate next steps */}
          {notDiseaseFund(context.state.diseaseFund.fundId) && (
            <p>
              Based on our pre-screen, you may be eligible to receive assistance
              from this fund. Please note that to be eligible for transportation
              assistance, you must be currently enrolled in a disease fund at
              PAN.
            </p>
          )}

          <p style={{ marginBottom: 0 }}>
            <a href="https://panapply.org/" className="btn" target="_blank" rel="noopener">
              Apply online today
            </a>
          </p>
        </Fragment>
      )}

      {context.state.role !== "patient" && (
        <Fragment>
          <p className="f-h3 u-mb1" style={{ margin: 0 }}>
            Your patient may be eligible for this fund!
          </p>
          <p style={{ margin: 0 }}>
            Based on our pre-screen, your patient may be eligible to receive
            assistance from this fund. Please note: they must be enrolled in a
            disease fund at PAN in order to qualify for transportation
            assistance.
          </p>

          <hr />

          {/* If the transportation fund was selected show the appropriate next steps */}
          {notDiseaseFund(context.state.diseaseFund.fundId) && (
            <Fragment>
              <p className="f-h5 c-purple u-mb1">How to apply</p>
              <p>
                Patients may apply directly for transportation assistance
                through the <a href={patientPortalURL}>patient portal</a> or by
                calling us at 1-866-316-7263. Healthcare providers and
                pharmacists may not apply on behalf of patients for this fund.
                Email this information to your patients by clicking the button
                below
              </p>
              <p>
                <a
                  className="btn"
                  href={`mailto:?subject=${mailToSubject}&body=${mailToBody}`}
                >
                  Share
                </a>
              </p>
            </Fragment>
          )}

          {/* Otherwise, show normal fund application next steps */}
          {!notDiseaseFund(context.state.diseaseFund.fundId) && (
            <Fragment>
              <p className="f-h5 c-purple u-mb1">Create an Account</p>
              <p>
                If this is your first time visiting the PAN Foundation, you must
                create an organization to access the grant portal. After your
                organization is approved, you can enroll eligible patients for
                assistance.
              </p>
              <p>
                <a
                  href="https://panfoundation.my.site.com/s/nonAuthFlow"
                  className="btn"
                >
                  Create an Account
                </a>
              </p>

              <hr />

              <p className="f-h5 c-purple u-mb1">Sign In</p>
              <p>
                If you already have a portal account, please sign in to the
                portal to enroll eligible patients or request additional funds.
              </p>
              <p>
                <a
                  href="https://panfoundation.my.site.com/s/nonAuthFlow"
                  className="btn"
                >
                  Sign In
                </a>
              </p>
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default Apply;
